module.exports = __webpack_public_path__ + "static/media/Home.40ac4f2c.jpg";